import type { QueryParamsDto } from "@mimber/schema"

export const eventsKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["events", "findAll", params] as const)
      : (["events", "findAll"] as const),
  findOne: (uuid: string) => ["events", "findOne", uuid] as const,
  findRegistrations: (eventUuid: string, params?: QueryParamsDto) =>
    params
      ? (["events", "findRegistrations", eventUuid, params] as const)
      : (["events", "findRegistrations", eventUuid] as const),
} as const

export const eventSeriesKeys = {
  findOne: (eventUuid: string) =>
    ["events", eventUuid, "series", "findOne"] as const,
} as const

export const eventTicketTiersKeys = {
  findAll: (eventUuid: string) =>
    ["event-ticket-tiers", "findAll", eventUuid] as const,
} as const

export const eventTicketsKeys = {
  findAll: (eventUuid: string) =>
    ["event-tickets", "findAll", eventUuid] as const,
} as const

export const eventRefundsKeys = {
  findAll: (eventUuid: string) =>
    ["event-refunds", "findAll", eventUuid] as const,
  findOne: (eventUuid: string, refundUuid: string) =>
    ["event-refunds", "findOne", eventUuid, refundUuid] as const,
} as const

export const eventAttendanceKeys = {
  findAll: (eventUuid: string, params?: QueryParamsDto) =>
    params
      ? (["event-attendance", "findAll", eventUuid, params] as const)
      : (["event-attendance", "findAll", eventUuid] as const),
  getStats: (eventUuid: string) =>
    ["event-attendance", "getStats", eventUuid] as const,
} as const

export const eventAttendanceOverviewKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["events", "attendance-overview", "findAll", params] as const)
      : (["events", "attendance-overview", "findAll"] as const),
} as const
